module.exports = __webpack_public_path__ + "img/img-16.879eb332.svg";